export default "__VITE_ASSET__CJO56axO__"